// src/hooks/useOtherSettings.ts
import { loadOtherSettings, OtherSettingsText } from "constants/otherSettings";
import { useSelector } from "react-redux";
import { State } from "rootExports/rootReducer";


export function useOtherSettings(): OtherSettingsText {
    const raw = useSelector((s: State) => s.Session?.FrontendSettings?.otherSettingsAsKeyValueText ?? null);
    return loadOtherSettings(raw);
}
